import { render } from "./LogoStyleGuide.vue?vue&type=template&id=2e4bed2c"
import script from "./LogoStyleGuide.vue?vue&type=script&lang=js"
export * from "./LogoStyleGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__